import { useState } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import LoginPage from "./Components/Login/LoginPage";
import Dashboard from "./Components/Dashboard/Dashboard";
import PointOfSales from "./Components/PointOfSales/PointOfSales";
import TopTen from "./Components/TopTen/TopTen";
import Inventory from "./Components/Inventory/Inventory";
import Accounts from "./Components/Accounts/Accounts";
import PurchasePlans from "./Components/PurchasePlans/PurchasePlans";
import Crm from "./Components/Crm/Crm";
import Graphs from "./Components/Graphs/Graphs";
import BarCodeCheck from "./Components/BarCodeCheck/BarCodeCheck";
import InvoiceWiseStock from "./Components/Inventory/InvoiceWiseStock";
import BarCodeScanner from "./Components/BarCodeScanner/BarCodeScanner";
import BluetoothPrinter from "./Components/BluetoothPrinter/BluetoothPrint";

function App() {
  const tenantName = localStorage.getItem("tenantName");
  const [isAuthenticated, setIsAuthenticated] = useState(
    // localStorage.getItem("isLoggedIn") === "true"
    tenantName
  );

  const handleLogin = (name) => {
    // localStorage.setItem("isLoggedIn", "true"); // Store login status
    setIsAuthenticated(name);
  };

  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage onLogin={handleLogin} />} />
        <Route
          path="*"
          element={
            isAuthenticated ? (
              <Routes>
                <Route path="/home" element={<Dashboard />} />
                <Route path="/point-of-sales" element={<PointOfSales />} />
                <Route path="/top-ten" element={<TopTen />} />
                <Route path="/inventory" element={<Inventory />} />
                <Route path="/accounts" element={<Accounts />} />
                <Route path="/purchase-plans" element={<PurchasePlans />} />
                <Route path="/crm" element={<Crm />} />
                <Route path="/graphs" element={<Graphs />} />
                <Route path="/bar-code-check" element={<BarCodeCheck />} />
                <Route path="/invoice-wise-stock" element={<InvoiceWiseStock />} />
                <Route path="/bar-code-scanner" element={<BarCodeScanner />} />
                <Route path="/bluetooth" element={<BluetoothPrinter />} />
              </Routes>
            ) : (
              <Navigate to="/" />
            )
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
